// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__FXD46","list":"styles_list__3kzYk"};